exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list__tile--active .v-icon[data-v-2f0fe2a0]{color:#01579b!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/Preautorizzato.vue?vue&type=style&index=0&id=2f0fe2a0&lang=scss&scoped=true&
// module id = 907
// module chunks = 0